//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//SHOPS
export const GET_SHOPS = "/shops";

//ORDERS
export const GET_ORDERS = "/orders";

//CART DATA
export const GET_CART_DATA = "/cart";
export const ADD_NEW_ORDER = "/add/order";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//CUSTOMER
export const CUSTOMER_LIST = "/customer/list";
export const CUSTOMER_CREATE = "/customer/create";
export const CUSTOMER_UPDATE = (ul_id) => `/customer/${ul_id}`;
export const DELETE_CUSTOMER = (ul_id) => `/customer/${ul_id}`;

//FILLER
export const FILLER_LIST = "/filler/list";
export const FILLER_CREATE = "/filler/create";
export const UPDATE_FILLER = (ul_id) => `/filler/${ul_id}`;
export const DELETE_FILLER = (ul_id) => `/filler/${ul_id}`;

// Transaction
export const TRANSACTION_LIST = "/transaction/list";
export const TRANSACTION_CREATE = "/transaction/create";
export const DELETE_TRANSACTION = (ul_id) => `/transaction/${ul_id}`;
export const UPDATE_TRANSACTION = (ul_id) => `/transaction/${ul_id}`;

// nozzle
export const NOZZLE_LIST = "/nozzel/list";
export const NOZZLE_CREATE = "/nozzel/create";
export const UPDATE_NOZZLE = (ul_id) => `/nozzel/${ul_id}`;
export const DELETE_NOZZLE = (ul_id) => `/nozzel/${ul_id}`;
export const UPDATE_NOZZLE_STOCK = `/nozzel/update_stock`;
export const GET_ASSIGNED_NOZZEL = "/nozzel/get_assigned_nozzel";
export const ASSIGN_NOZZEL = (ul_id) => `/assign_nozzel/${ul_id}`;
export const UNASSIGN_NOZZEL = (ul_id) => `/unassign_nozzel/${ul_id}`;

// Price List
export const PRICE_LIST = "/product/list";
export const PRICE_CREATE = "/product/create";
export const UPDATE_PRICE = (ul_id) => `/product/${ul_id}`;
export const DELETE_PRICE = (ul_id) => `/product/${ul_id}`;

export const ORDER_LIST = "/order/list";
export const REPORT_LIST = "/order/generate_invoice";
export const LEDGER_REPORT = "/general/generate_report";
export const SEND_PDF = "/general/send_pdf";
export const ORDER_CREATE = "/order/create";
export const UPDATE_ORDER = (ul_id) => `/order/${ul_id}`;
export const DELETE_ORDER = (ul_id) => `/order/${ul_id}`;

//Dahashboard
export const DASHBOARD = "/dashboard/list";

//Users
export const USER_LIST = "/admin/list";
export const USER_CREATE = "/admin/create";
export const USER_UPDATE = (ul_id) => `/admin/${ul_id}`;
export const DELETE_USER = (ul_id) => `/admin/${ul_id}`;
export const USER_PROFILE = `/profile`;
export const RESET_PASSWORD = `/reset-password`;

export const GET_ACCOUNTANT_HISTORY = "/general/accountant_history";
export const GET_STOCK_HISTORY = "/general/stock_entries";
